import { lazyWrap } from '@neptune/shared/common-ui';

export const LazyReportContainer = lazyWrap(
  async () =>
    (await import(/* webpackChunkName: "reports" */ '@neptune/reports-feature'))
      .ReportViewContainer,
);
